(() => {
  let pressedLink = null;
  let releaseTimer;

  const clearPressedLink = () => {
    pressedLink?.classList.remove('th-menu-link-pressed');
    pressedLink = null;
  };

  const pressLink = (target) => {
    if (!(target instanceof Element)) return;
    const link = target.closest('.th-mobile-menu nav a');
    if (!link) return;
    clearTimeout(releaseTimer);
    clearPressedLink();
    pressedLink = link;
    link.classList.add('th-menu-link-pressed');
  };

  document.addEventListener('pointerdown', (event) => {
    if (event.button === 0) pressLink(event.target);
  });

  document.addEventListener('pointerup', () => {
    releaseTimer = setTimeout(clearPressedLink, 180);
  });

  document.addEventListener('pointercancel', clearPressedLink);

  document.addEventListener('pointerout', (event) => {
    if (pressedLink && !pressedLink.contains(event.relatedTarget)) clearPressedLink();
  });

  document.addEventListener('toggle', (event) => {
    const details = event.target;
    if (!(details instanceof Element) || !details.matches('.th-mobile-menu')) return;
    const summary = details.querySelector('summary');
    if (!summary) return;
    summary.setAttribute('aria-expanded', String(details.open));
    summary.setAttribute('aria-label', details.open ? summary.dataset.closeLabel : summary.dataset.openLabel);
  }, true);

  document.addEventListener('click', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;
    pressLink(target);
    releaseTimer = setTimeout(clearPressedLink, 180);
    document.querySelectorAll('.th-header details[open]').forEach((details) => {
      if (!details.contains(target)) details.removeAttribute('open');
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.th-header details[open]').forEach((details) => {
      details.removeAttribute('open');
      details.querySelector('summary')?.focus();
    });
  });
})();
